import {
  Number as RTNumber,
  Partial,
  Record,
  Static,
  String as RTString
} from 'runtypes';

export const ExistingAccount = Record({
  investmentVehicle: Record({
    ticker: RTString,
    trpCode: RTString
  }),
  fundingDetails: Record({
    fundingAmount: RTNumber,
    fundingAmountPercentage: RTNumber
  }),
  agreementID: RTString
});

export type StaticExistingAccount = Static<typeof ExistingAccount>;

export const Investment = Partial({
  ticker: RTString,
  trpCode: RTString,
  fundingAmount: RTNumber,
  fundingDetails: Record({
    fundingAmount: RTNumber,
    fundingAmountPercentage: RTNumber
  }),
  federalWithholdingPercentForDividends: RTNumber
});

export type StaticInvestment = Static<typeof Investment>;
